import { AnimatePresence } from "motion/react";
import { FC, PropsWithChildren, ReactElement, useState } from "react";

import {
  ConflictsCollapseIcon,
  PreviewLineWithArrowStyled,
} from "./common.styled";

interface IExpandedProps extends PropsWithChildren {
  NavControl: ReactElement;
  defaultExpanded?: boolean;
}

export const Expanded: FC<IExpandedProps> = ({
  children,
  NavControl,
  defaultExpanded = false,
}) => {
  const [isExpanded, setExpanded] = useState(defaultExpanded);
  return (
    <>
      <PreviewLineWithArrowStyled
        onClick={() => setExpanded(isExpandedValue => !isExpandedValue)}
      >
        {NavControl}
        <ConflictsCollapseIcon isExpanded={isExpanded} />
      </PreviewLineWithArrowStyled>
      <AnimatePresence initial={false}>
        {isExpanded && children}
      </AnimatePresence>
    </>
  );
};
